module.exports = __webpack_public_path__ + "img/c00_buildingtechstrongholdtower_Normal_ua.b3a519ff.webp";